export const exportToCSV = ({
    data = [],
    columns = [],
    fileName = "export"
}) => {
    if (!data.length) return;

    const headers = columns.map(col => col.label);

    const rows = data.map(row =>
        columns.map(col => {
            let value = row[col.key];

            if (value === null || value === undefined) return "";

            // Escape commas & quotes
            value = String(value).replace(/"/g, '""');
            return `"${value}"`;
        })
    );

    const csvContent = [
        headers.join(","),
        ...rows.map(r => r.join(","))
    ].join("\n");

    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${fileName}.csv`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};